import { Component } from '@angular/core'
import { DynatraceService } from '../../libs/drrweb-lib/src/lib/shared/services/dynatrace.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html'
})
export class AppComponent {
  constructor(
    private _: DynatraceService
  ) {}

}
